import { render, staticRenderFns } from "./MagicCubeSetting.vue?vue&type=template&id=d55f75fa&scoped=true&"
import script from "./MagicCubeSetting.vue?vue&type=script&lang=js&"
export * from "./MagicCubeSetting.vue?vue&type=script&lang=js&"
import style0 from "./MagicCubeSetting.vue?vue&type=style&index=0&id=d55f75fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f75fa",
  null
  
)

export default component.exports